import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.51937 4.91466C10.442 3.97928 11.0016 2.9551 11.0016 2H13.0016C13.0016 2.95572 13.5614 3.98036 14.4838 4.91586C15.3941 5.83906 16.5215 6.53315 17.3483 6.84034C17.6848 6.96537 17.9022 7 18 7L19 7V9L18 9L18 11L6.00235 11V9L5.00002 9V7H6.00002C6.09814 7 6.3162 6.9652 6.65383 6.83965C7.48135 6.53194 8.60896 5.83767 9.51937 4.91466Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 13.0001V15.0001H3L3 20.0001H2V22.0001H11.002L11.002 18H13.002L13.002 22.0001H22V20.0001H21V15.0001H22V13.0001H2Z"}}]};

const CityAncient1Filled = Vue.extend<IconProps>({
  name: 'CityAncient1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'city-ancient-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CityAncient1Filled;
